exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AnswerCard-caller-m472U{padding:17px 0}.AnswerCard-questionGroup-2QzKO{margin:10px 0 0;padding:10px 0 0;list-style-type:none;border-top:1px solid #d6dde1}.AnswerCard-questionGroup-2QzKO>li{display:block}.AnswerCard-questionGroup-2QzKO>li h4{text-align:center;text-transform:none;margin-top:11px;margin-bottom:11px;font-weight:300}.AnswerCard-questionGroup-2QzKO>li p{overflow:hidden;margin:10px 0;padding:0}.AnswerCard-questionGroup-2QzKO>li p>i{float:left;margin-right:10px}.AnswerCard-questionGroup-2QzKO>li p>span{display:block;overflow:hidden}.AnswerCard-globalComment-1TqBC h4{text-align:center;text-transform:none;margin-top:11px;margin-bottom:11px;font-weight:300}.AnswerCard-globalComment-1TqBC p{overflow:hidden;margin:10px 0;padding:0}.AnswerCard-globalComment-1TqBC p>i{float:left;margin-right:10px}.AnswerCard-globalComment-1TqBC p>span{display:block;overflow:hidden}", ""]);

// exports
exports.locals = {
	"caller": "AnswerCard-caller-m472U",
	"questionGroup": "AnswerCard-questionGroup-2QzKO",
	"globalComment": "AnswerCard-globalComment-1TqBC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/satisfaction/components/AnswerCard.less
// module id = 1743
// module chunks = 0